// Ordnet Attribut-IDs den statischen Newsletter-Icon-PNGs zu
// (assets-static/attribute_<key>_white.png, generiert aus front
// General/AttributIcon.jsx — Alias-Gruppen dort gespiegelt halten!).
// width/height = Anzeige-Maße (10px hoch, Breite proportional zur PNG-Natur-
// größe @20px) — Outlook braucht beide Attribute explizit, sonst verzerrt es.
// Überbreite Logos (Cinedom X, ScreenX …) werden proportional auf MAX_WIDTH
// gedeckelt, damit der Chip die 85px-Grid-Zelle nicht sprengt.
// null = keine Grafik vorhanden, Chip zeigt den Attributnamen als Text.
const DISPLAY_HEIGHT = 10
const MAX_WIDTH = 64

// Naturbreiten der generierten PNGs bei 20px Höhe
const ICONS = {
  ov: 37,
  omu: 60,
  omeu: 77,
  omdu: 74,
  '2d': 31,
  '3d': 32,
  atmos: 54,
  'cinedom-x': 145,
  dbox: 54,
  hdr: 62,
  imax: 105,
  forumax: 82,
  screenx: 158,
  mx4d: 66,
  '4dx': 51,
  '4k': 33,
  filmfruehstueck: 140,
  kultur: 80,
  'kino-anders': 80,
}

// Sprach-/Untertitel-Glyphen sind quadratisch statt flach: auf 10px waeren die
// zwei Buchstaben ~4px hoch und unlesbar. Sie liegen mit 32px Quellhoehe vor und
// werden auf 16px angezeigt (gleicher 2x-Faktor wie die Logos bei 20/10).
const GLYPH_SOURCE_HEIGHT = 32
const GLYPH_DISPLAY_HEIGHT = 16

// Naturbreiten bei GLYPH_SOURCE_HEIGHT
const GLYPH_ICONS = {
  'lang-de': 33,
  'lang-de-ch': 33,
  'lang-en': 33,
  'lang-es': 32,
  'lang-fr': 33,
  'lang-it': 33,
  'lang-tr': 32,
  'lang-ru': 33,
  'lang-zh': 32,
  'lang-ja': 33,
  'lang-ko': 33,
  'lang-el': 33,
  'lang-hi': 33,
  'lang-ta': 33,
  'lang-ku': 33,
  'lang-bo': 33,
  'sub-de': 32,
  'sub-en': 32,
  'sub-fr': 32,
  'sub-it': 32,
  'sub-ja': 32,
}

const ICON_KEY_BY_ID = {
  ov: 'ov', original: 'ov', originalversion: 'ov',
  omu: 'omu', OmU: 'omu', subtitled: 'omu',
  omeu: 'omeu', OmeU: 'omeu',
  omdu: 'omdu', OmdU: 'omdu', OMdU: 'omdu',
  '3d': '3d', 1088: '3d', filmtype_3: '3d',
  '2d': '2d', 1087: '2d', filmtype_2: '2d',
  atmos: 'atmos', 1522: 'atmos', ATMOS: 'atmos', 'DOLBY ATMOS': 'atmos', 'dolby atmos': 'atmos', filmtype_25: 'atmos',
  'cinedom x': 'cinedom-x', cinedomx: 'cinedom-x',
  dbox: 'dbox', 1666: 'dbox', DBox: 'dbox', 'd box': 'dbox', 'd-box': 'dbox',
  hdr: 'hdr',
  imax: 'imax',
  forumax: 'forumax',
  screenx: 'screenx',
  mx4d: 'mx4d', MX4D: 'mx4d',
  '4dx': '4dx',
  '4k': '4k', '4K': '4k',
  'filmfrühstück': 'filmfruehstueck',
  kultur: 'kultur',
  'kino anders': 'kino-anders', kinoanders: 'kino-anders', kino_anders: 'kino-anders',
  // Sprach- und Untertitel-Glyphen (generiert von scripts/generateAttributeIcons.cjs)
  deutsch: 'lang-de',
  schweizerdeutsch: 'lang-de-ch',
  'english/englisch': 'lang-en',
  'español/spanisch': 'lang-es',
  'français/französisch': 'lang-fr',
  'italiano/italienisch': 'lang-it',
  'türkçe/türkisch': 'lang-tr',
  'русский/russisch': 'lang-ru',
  '中文 / chinesisch': 'lang-zh',
  '日本語/japanisch': 'lang-ja',
  '한국어 / koreanisch': 'lang-ko',
  'ελληνικά / griechisch': 'lang-el',
  'हिंदी / hindi': 'lang-hi',
  'தமிழ் / tamilisch': 'lang-ta',
  'kurdî / kurdisch': 'lang-ku',
  tibetisch: 'lang-bo',
  'deutsch untertitel': 'sub-de',
  'englisch untertitel': 'sub-en',
  'französisch untertitel': 'sub-fr',
  'italienisch untertitel': 'sub-it',
  'japanisch untertitel': 'sub-ja',
  // 'englisch', 'türkisch', 'japanisch' bewusst NICHT hier: die Komponente
  // rendert dafuer <p>-Text statt eines SVG, es gibt also kein Icon. Sie
  // bleiben im Newsletter Textzeilen — gleiche Quelle, gleiche Entscheidung.
}

const getAttributeIconFile = (attributeId) => {
  const key = ICON_KEY_BY_ID[attributeId]
  if (!key) return null

  if (GLYPH_ICONS[key]) {
    return {
      file: `attribute_${key}_white.png`,
      width: Math.round(GLYPH_ICONS[key] * GLYPH_DISPLAY_HEIGHT / GLYPH_SOURCE_HEIGHT),
      height: GLYPH_DISPLAY_HEIGHT,
    }
  }

  const naturalWidth = ICONS[key]
  let width = Math.round(naturalWidth * DISPLAY_HEIGHT / 20)
  let height = DISPLAY_HEIGHT
  if (width > MAX_WIDTH) {
    height = Math.round(DISPLAY_HEIGHT * MAX_WIDTH * 2 / naturalWidth)
    width = MAX_WIDTH
  }
  return {
    file: `attribute_${key}_white.png`,
    width: width,
    height: height,
  }
}

export default getAttributeIconFile
